import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../../context/AuthContext';
import PolicyRulesPanel from '../../../components/ui/PolicyRulesPanel';

// "Atama Kuralları" sekmesi (AKM POC §6.2). Kişi başı "Kullanıcı Ata" penceresi ve atanmış kullanıcı
// listesi KALDIRILDI: politika artık kural ile (kişi / grup / statü / departman / lokasyon / alt şirket /
// tüm şirket, geçerlilik başlangıcıyla) atanır. Eski kişi başı atamalar (User.LeavePolicyId) panelde
// "Kişiye Özel (Eski Atama)" satırı olarak görünür ve kaldırılabilir. Yazma kapısı izin modülü (LM).
export default function LeavePolicyUsersTab({ policyId }) {
  const { t } = useTranslation();
  const { canWrite } = useAuth();

  return (
    <PolicyRulesPanel
      kind="leavePolicy"
      policyId={policyId}
      title={t('leavePolicy.assignmentRules')}
      canWrite={canWrite('LM')}
    />
  );
}
